// Order-related types matching Supabase schema

export type OrderStatus = 'da_pagare' | 'pagato' | 'in_preparazione' | 'pronto' | 'annullato';
export type PaymentMethod = 'stripe' | 'contanti' | 'satispay' | 'pos_carta';
export type GlutenOption = 'con_glutine' | 'senza_glutine';

export interface Order {
  id: string;
  customer_name: string;
  customer_email: string;
  customer_phone: string;
  pickup_time: string | null;
  order_note: string | null;
  status: OrderStatus;
  payment_method: PaymentMethod;
  is_paid: boolean;
  paid_at: string | null;
  currency: string;
  subtotal_cents: number;
  total_cents: number;
  stripe_checkout_session_id: string | null;
  stripe_payment_intent_id: string | null;
  satispay_reference: string | null;
  cancel_reason: string | null;
  customer_access_token: string;
  created_at: string;
  updated_at: string;
}

export interface OrderItem {
  id: string;
  order_id: string;
  product_id: string | null;
  name_snapshot: string;
  unit_price_cents: number;
  quantity: number;
  gluten_option: GlutenOption;
  line_total_cents: number;
  created_at: string;
}

export interface OrderWithItems extends Order {
  order_items: OrderItem[];
}

export interface CreateOrderRequest {
  customer_name: string;
  customer_email: string;
  customer_phone: string;
  pickup_time: string | null;
  order_note: string | null;
  payment_method: 'stripe' | 'contanti' | 'satispay' | 'pos_carta';
  items: {
    product_id: string | null;
    name_snapshot: string;
    unit_price_cents: number;
    quantity: number;
    gluten_option: GlutenOption;
  }[];
}

export interface CreateOrderResponse {
  order_id: string;
  customer_access_token: string;
  short_code: string;
  checkout_url?: string; // Only for Stripe payments
}

export interface OrderStatusResponse {
  id: string;
  status: OrderStatus;
  payment_method: PaymentMethod;
  is_paid: boolean;
  pickup_time: string | null;
  total_cents: number;
  created_at: string;
  items: {
    name_snapshot: string;
    quantity: number;
    gluten_option: GlutenOption;
    line_total_cents: number;
  }[];
  can_cancel: boolean;
}

export const STATUS_LABELS: Record<OrderStatus, string> = {
  'da_pagare': 'Da pagare',
  'pagato': 'Pagato',
  'in_preparazione': 'In preparazione',
  'pronto': 'Pronto per il ritiro',
  'annullato': 'Annullato'
};

export const PAYMENT_METHOD_LABELS: Record<PaymentMethod, string> = {
  'stripe': 'Carta online',
  'contanti': 'Contanti',
  'satispay': 'Satispay',
  'pos_carta': 'Carta/Apple Pay/Google Pay al ritiro'
};
